<template>
    <div class="row">
        <div class="col-md-6">
            <multiselect
            v-model="value"
            :options="options"
            :custom-label="nameWithId"
            placeholder="Type to search"
            @select="centreSelected"
            @remove="reset">
                <template #noResult>
                  <span>
                      Centre not found. This user may not have access to this centre.
                  </span>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: "UserCentreSelectComponent",
    components: {
        Multiselect
    },
    props: {
        options: {
            type: [Object, Array],
            default: () => ({}),
            require: true,
        }
    },
    data: () => {
        return {
            value: [],
        }
    },
    methods: {
        nameWithId ({ name, titan_id }) {
            return `${name} - ${titan_id}`
        },
        reset () {
            this.$emit('reset')
        },
        centreSelected: function (centre) {
            this.$emit('select:centre', centre)
        }
    }
}
</script>

<style scoped>
.multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px!important;
}

.multiselect__option {
    min-height: 14px!important;
}

.multiselect__option:after {
    line-height: 14px!important;
}
</style>
